import useApi from 'hooks/useApi';

export const useOffboardValidations = () => {
  const api = useApi();

  return async (id: number) => {
    try {
      const response = await api({
        url: `/v3/admin/locations/${id}/offboard_validation`,
        method: 'GET',
      });

      const data = response.data;

      if (!data || !data.location) {
        throw new Error('Invalid API response: Missing location data');
      }

      return {
        location: {
          id: data.location.id,
          name: data.location.name,
          status: data.location.status,
        },
        validationPassed: data.validation_passed ?? false,
        isLastActiveLocation: data.is_companies_last_active_location ?? false,
        validations: data.validations ? data.validations : [],
      };
    } catch (error: any) {
      console.error('Error fetching offboard validations:', error);
      if (error.response?.status === 404) {
        throw new Error('Invalid location ID');
      } else if (error.response?.status === 401) {
        throw new Error('Unauthorized access');
      } else {
        throw new Error('An error occurred while fetching offboard validations');
      }
    }
  };
};
